import { render, staticRenderFns } from "./NotificationSubscriber.vue?vue&type=template&id=8d9bb082&"
import script from "./NotificationSubscriber.vue?vue&type=script&lang=js&"
export * from "./NotificationSubscriber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports